import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DialogTitle, DialogContentText, TextField, Box, Autocomplete } from '@mui/material';

AccountInformation.propTypes = {
  setFacility: PropTypes.func,
  facility: PropTypes.object,
  setCompany: PropTypes.func,
  company: PropTypes.object,
  allFacilities: PropTypes.array,
  allCompanies: PropTypes.array,
};
export default function AccountInformation({ facility, setFacility, company, setCompany, allFacilities, allCompanies }) {

   const [facilities, setFacilities] = useState([]);
  
  useEffect(() => {
    if (company !== null && Object.keys(company).length !== 0) {
      setFacilities(allFacilities?.filter(f => f.companyId === company?.id) ?? []);
    }
   else(
     setFacilities(allFacilities)
   )
  }, [company, allFacilities]);
  return (
    <>
      <DialogTitle
        sx={{
          textAlign: 'center',
          color: 'rgba(112, 112, 112, 0.5)',
        }}
      >
        Account Information
      </DialogTitle>
        <div>
          <DialogContentText sx={{ fontWeight: 'bold' }}>Group Name</DialogContentText>{' '}
          <Autocomplete
            sx={{
              width: '100%',
              mt: 1,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': 'none',
            }}
            type="new-password"
            options={[...allCompanies || []].sort((a, b) => a.name.localeCompare(b.name))}
            autoHighlight
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option?.name === value?.name}
            value={company}
            onChange={(event, newValue) => {
              setCompany(newValue);
              setFacility('');
            }}
            renderOption={(props, option) => (
              <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                {option?.name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                variant="outlined"
                autoComplete="off"
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </div>
      <DialogContentText sx={{ fontWeight: 'bold', mt: 3 }}>Facility Name</DialogContentText>
      <Autocomplete
        sx={{
          width: '100%',
          mt: 1,
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiFormLabel-root ': 'none',
        }}
        type="new-password"
        options={[...facilities].sort((a, b) => a.facilityName.localeCompare(b.facilityName))}
        autoHighlight
        getOptionLabel={(option) => option?.facilityName || ''}
        isOptionEqualToValue={(option, value) => option?.facilityName === value?.facilityName}
        value={facility}
        onChange={(event, newValue) => {
          setFacility(newValue);
        }}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            {option?.facilityName}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            variant="outlined"
            autoComplete="off"
          />
        )}
        disabled={company === null}
      />
    </>
  );
}
